import { CHARTING_MULTIPLIER_BY_CODE } from './TradingView';

export const capitalizeFirstLetter = string => {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

export const isQuarterlyData = indicatorCode => {
  const list = [
    'NetIncome',
    'GrossProfit',
    'GrossProfitMargin',
    'NetProfit',
    'NetProfitMargin',
    'NetRevenue',
    'ROA',
    'ROE',
    'TotalAsset',
    'TotalLiabilities',
    'CurrentAsset',
    'CurrentLiabilities',
    'Equity',
    'EBITMargin',
    'TotalLoans',
    'TotalDeposit',
  ];

  return list.includes(indicatorCode);
};

export const drawImageToCanvas = (ctx, content, dy) =>
  new Promise(resolve => {
    const image = new Image();
    image.onload = () => {
      ctx.drawImage(image, 0, dy);
      resolve(true);
    };
    image.src = content;
  });

export const getImage = data => {
  const width = data[0].contentWidth;
  const imageData = data.reduce(
    (result, item) => {
      return {
        height: result.height + item.contentHeight,
        items: result.items.concat({
          ...item,
          dy: result.height,
        }),
      };
    },
    { height: 0, items: [] },
  );
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = imageData.height;
  const ctx = canvas.getContext('2d');
  const promises = imageData.items.map(item =>
    drawImageToCanvas(ctx, item.content, item.dy),
  );
  return Promise.all(promises).then(() => canvas.toDataURL('image/jpeg'));
};

export const takeScreenShot = widget =>
  new Promise(resolve => {
    // widget.showSaveAsChartDialog();
    widget.takeClientScreenshot().then(screenshotCanvas => {
      resolve(screenshotCanvas.toDataURL('image/jpeg'));
    });
  });

export const setMultiplierByCode = ({
  ticker,
  code,
  resolution,
  maxValue,
  isTrillion = true,
  isBillion = true,
  isMillion = true,
  isThousand = true,
}) => {
  const getMultiplier = value => {
    if (value >= 10 ** 12 && isTrillion) return 10 ** 12;
    if (value >= 10 ** 9 && isBillion) return 10 ** 9;
    if (value >= 10 ** 6 && isMillion) return 10 ** 6;
    if (value >= 10 ** 3 && isThousand) return 10 ** 3;
    return 1;
  };

  const localStrValue = localStorage.getItem(CHARTING_MULTIPLIER_BY_CODE);
  let localObjValue = localStrValue ? JSON.parse(localStrValue) : {};
  let oldKey = Object.keys(localObjValue).find(val => val.includes(code));
  const key = `${ticker}_${code}_${resolution}`;
  const multiplier = getMultiplier(maxValue);

  if (oldKey) {
    if (oldKey === key) {
      if (localObjValue[oldKey] < multiplier) {
        localObjValue[oldKey] = multiplier;
      }
    } else {
      delete localObjValue[oldKey];
      localObjValue[key] = multiplier;
    }
  } else {
    localObjValue[key] = multiplier;
  }

  localStorage.setItem(
    CHARTING_MULTIPLIER_BY_CODE,
    JSON.stringify(localObjValue),
  );
};

export const getMultiplierByCode = code => {
  const localStrValue = localStorage.getItem(CHARTING_MULTIPLIER_BY_CODE);
  const localObjValue = localStrValue ? JSON.parse(localStrValue) : {};
  const key = Object.keys(localObjValue).find(key => key.includes(code));
  return key ? localObjValue[key] : 1;
};

export const getUnitByMultiplier = multiplier => {
  if (multiplier === 10 ** 12) return 'T';
  if (multiplier === 10 ** 9) return 'B';
  if (multiplier === 10 ** 6) return 'M';
  if (multiplier === 10 ** 3) return 'K';
  return '';
};

export const getTimeFrameObj = interval => {
  let timeframe = {
    type: 'period-back',
  };
  let fromOption = {
    number: 1,
    unit: 'day',
  };
  switch (interval) {
    case '1':
      timeframe.value = '1D';
      break;
    case '5':
      timeframe.value = '7D';
      fromOption = {
        number: 7,
        unit: 'day',
      };
      break;
    case '15':
      timeframe.value = '15D';
      fromOption = {
        number: 15,
        unit: 'day',
      };
      break;
    case '30':
      timeframe.value = '1M';
      fromOption = {
        number: 1,
        unit: 'month',
      };
      break;
    case '60':
      timeframe.value = '2M';
      fromOption = {
        number: 2,
        unit: 'month',
      };
      break;
    case '120':
      timeframe.value = '4M';
      fromOption = {
        number: 4,
        unit: 'month',
      };
      break;
    case '240':
      timeframe.value = '6M';
      fromOption = {
        number: 6,
        unit: 'month',
      };
      break;
    case '1D':
      timeframe.value = '12M';
      fromOption = {
        number: 1,
        unit: 'year',
      };
      break;
    default:
      return;
  }
  return { timeframe, fromOption };
};

export const getIndicatorHistoricalPeriod = period => {
  switch (period) {
    case '1D':
    case '1W':
    case '1M':
    case '3M':
    case '12M':
      return '1D';
    default:
      return period;
  }
};

export const getIndicatorHistoricalNumberBars = period => {
  switch (period) {
    case '1W':
      return 5;
    case '1':
    case '60':
    case '1D':
    default:
      return 1;
  }
};
